module.exports = __webpack_public_path__ + "static/media/spinneret_arrival.42abcd89.jpg";